import React from 'react';
import { cn } from "../../../utils/cn"; 
import { useTheme } from '../../../context/ThemeContext';

const Input = ({
  label,
  id,
  name,
  type = 'text',
  isRequired = false,
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  icon,
  iconPosition = 'right',
  containerStyle = '',
  labelStyle = '',
  inputStyle = '',
  errorStyle = '',
  className = '',
  ...props
}) => {
  const { theme } = useTheme();

  return (
    <div className={cn('flex flex-col gap-2 w-full font-inter', containerStyle)}>
      {/* Label */}
      {label && (
        <label
          htmlFor={id}
          className={cn(
            'text-base font-medium text-[var(--color-content)]',
            isRequired && 'flex items-center',
            labelStyle
          )}
        >
          {label}
          {isRequired && <span className="ml-1 text-light-red">*</span>}
        </label>
      )}

      {/* Input / Textarea wrapper */}
      <div className="relative flex items-center">
        {type === 'textarea' ? (
          <textarea
            id={id}
            name={name}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            className={cn(
              'input-base',
              error && 'input-error',
              icon && iconPosition === 'left' && 'input-icon-left',
              icon && iconPosition === 'right' && 'input-icon-right',
              'input-textarea',
              className,
              inputStyle
            )}
            {...props}
          />
        ) : (
          <input
            type={type}
            id={id}
            name={name}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            className={cn(
              'input-base',
              error && 'input-error',
              icon && iconPosition === 'left' && 'input-icon-left',
              icon && iconPosition === 'right' && 'input-icon-right',
              className,
              inputStyle
            )}
            {...props}
          />
        )}

        {icon && (
          <span
            className={cn(
              'absolute top-1/2 -translate-y-1/2 text-[var(--color-content)]',
              iconPosition === 'left' ? 'icon-left' : 'icon-right'
            )}
          >
            {icon}
          </span>
        )}
      </div>

      {/* Error message */}
      {error && (
        <span className={cn('text-sm font-medium text-light-red', errorStyle)}>
          {error}
        </span>
      )}
    </div>
  );
};

export default Input;
